/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Directive, Input } from '@angular/core';

@Directive({
  standalone: false,
  selector: '[automation-id]',
  host: {
    '[attr.data-automation-id]': 'automationId',
  },
})
export class AutomationIDDirective {
  @Input('automation-id') automationId: string;
}
